/**
 * OKR Custom Node Components
 * Export all custom ReactFlow nodes
 */

import { CompanyOKRNode } from './CompanyOKRNode';
import { DepartmentOKRNode } from './DepartmentOKRNode';
import { TeamOKRNode } from './TeamOKRNode';
import { IndividualOKRNode } from './IndividualOKRNode';

// Re-export individual components
export { CompanyOKRNode, DepartmentOKRNode, TeamOKRNode, IndividualOKRNode };

// Node type mapping for ReactFlow
export const nodeTypes = {
  company: CompanyOKRNode,
  department: DepartmentOKRNode,
  team: TeamOKRNode,
  individual: IndividualOKRNode,
};
